import { useParams } from '@/shared/modern-router';

import {
  PageLayoutBreadcrumb,
  PageLayoutHeader,
  PageLayoutSubtitle,
  PageLayoutTitle,
  PageLayoutTop,
} from '@/shared/components/page-layout';

import { useTranslation } from './hooks';

const HeaderDashboard = () => {
  const { t } = useTranslation();
  const { processId } = useParams<{ processId: string }>();

  const breadcrumbs = [
    {
      text: t('performance'),
      href: `/org/[slug]/talent/panel/employee/performance/pid/${processId}/`,
    },
    {
      text: t('PID'),
    },
  ];

  return (
    <PageLayoutTop>
      <PageLayoutBreadcrumb items={breadcrumbs} />
      <PageLayoutHeader>
        <PageLayoutTitle title={t('PID_TITLE')} />
        <PageLayoutSubtitle>{t('PID_DESCRIPTION')}</PageLayoutSubtitle>
      </PageLayoutHeader>
    </PageLayoutTop>
  );
};

export default HeaderDashboard;
